"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteNotificationApiCall = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const deleteNotificationApiCall = (url, id) => (0, abortable_fetch_1.abortableFetch)(`${url}/received/${id}`, {
    method: 'DELETE',
});
exports.deleteNotificationApiCall = deleteNotificationApiCall;
//# sourceMappingURL=delete-hook.js.map